import hexToRgb from "./hexToRgb";

/**
 * Returns an `rgba(...)` css value from a hex/rgb color and an opacity.
 */
function rgba(color, opacity) {
  const rgbValue = color.startsWith("#") ? hexToRgb(color) : color;
  return `rgba(${rgbValue}, ${opacity})`;
}

export default rgba;
